import type { Translation } from "../i18n-types";

const de = {
	WELCOME_LONG: "مرحبا بك في القاعة Unicorn Digital Courtroom",
	WELCOME: "مرحبا {name}!",
	JOIN_ROOM_DESCRIPTION:
		"انضم إلى إحدى الغرف المدرجة أدناه أو أنشئ غرفتك الخاصة!",
	NO_ROOM: "لا ترى الغرفة التي تبحث عنها؟ أنشئ غرفتك الخاصة.",
	CREATE_ROOM: "إنشاء غرفة",
	ROOM: "الغرفة",
	ACCESSIBILITY_SETTINGS: "إعدادات إمكانية الوصول",
	ACCESSIBILITY_SETTINGS_DESCRIPTION: "قم بتغيير إعدادات إمكانية الوصول هنا",
	CONTRAST: "مقابلة",
	SELECT_DISPLAY_NAME: "الرجاء إدخال اسم العرض الذي ترغب في استخدامه",
	SOMETHING_WENT_WRONG: "هناك خطأ ما.",
	GO_BACK: "عد",
	GO_BACK_TO_ROOM: "العودة إلى الغرفة",
	EXPAND: "توسيع",
	EXPORT: "تصدير",
	JOIN_ROOM: "الانضمام إلى الغرفة",
	ROOM_ENDED_TITLE: "انتهت الغرفة",
	ROOM_ENDED_DESCRIPTION: "انتهت الغرفة، ستتم إعادة توجيهك إلى الشاشة الرئيسية",
	RENAME_FAILED: "فشلت عملية إعادة التسمية.",
	TRANSCRIPT_DISCLAIMER:
		"نص مكتوب استنادا إلى الأشخاص المحددين. يجب أن تتحدث لأكثر من 7 ثواني لتكون محددا.",
	CHANGE_SPEAKER_TITLE: "تغيير المتحدث",
	CHANGE_SPEAKER_DESCRIPTION: "تغيير اسم المتحدث واللون هنا",
	PREVIEW_MESSAGE: "مرحبا هذه رسالة المعاينة",
	COLOR: "اللون",
	NAME: "الاسم",
	LANGUAGE: "اللغة",
	CANCEL: "إلغاء",
	SAVE: "حفظ",
	ROOM_ID: "معرف الغرفة",
	ROOM_ID_FORM_PLACEHOLDER: "أدخل معرف الغرفة للانضمام",
	ROOM_ID_FORM_REQUIRED: "معرف الغرفة مطلوب للانضمام",
	ROOM_ID_FORM_MIN_LENGTH: "يجب أن يكون معرف الغرفة 17 حرفا",
	LOGIN: "تسجيل الدخول",
	ROOM_COL: "الغرفة:",
	LANGUAGE_COL: "اللغة",
	END_ROOM: "إنهاء الغرفة",
	JOIN_NOW: "انضم الآن",
	LOGIN_FORM: {
		TOAST_TITLE: "تم تسجيل الدخول!",
		TOAST_DESCRIPTION: "يمكنك الآن إنشاء/الانضمام إلى غرفة!",
		DISPLAY_NAME: "اسم العرض",
		DISPLAY_NAME_FORM_PLACEHOLDER: "أدخل اسم العرض",
		DISPLAY_NAME_FORM_SHORT: "يجب أن يكون اسم العرض على الأقل 3 أحرف",
		DISPLAY_NAME_FORM_LONG: "يجب أن يكون اسم العرض على الأكثر 32 حرفا",
		DISPLAY_NAME_FORM_REQUIRED: "اسم العرض مطلوب",
	},
	PROFILE_FORM: {
		TITLE: "أكمل ملفك الشخصي",
		DESCRIPTION: "الرجاء إدخال اسم العرض للبدء",
		TOAST_SUCCESS_TITLE: "تم تحديث الملف الشخصي!",
		TOAST_SUCCESS_DESCRIPTION: "تم حفظ ملفك الشخصي بنجاح.",
		TOAST_ERROR_TITLE: "فشل التحديث",
		TOAST_ERROR_DESCRIPTION:
			"فشل في تحديث ملفك الشخصي. يرجى المحاولة مرة أخرى.",
		SUBMIT_BUTTON: "حفظ الملف الشخصي",
	},
	DIARIZATION: {
		UNDETECTED: "غير مكتشف",
		ACCURACY: "الدقة",
		ID: "المعرف",
		LEXICAL: "المصطلحات",
		ITN: "التعريف التلقائي",
		MASKED_ITN: "التعريف التلقائي المخفي",
		LANGUAGE: "اللغة",
		ORIGINAL_TEXT: "النص الأصلي",
		SPEAKER: "المتحدث",
	},
	NO_ROOMS_LIST: "عذرا، لا يمكن العثور على أي غرف.",
	SEARCH_FOR_A_ROOM: "البحث عن غرفة",
	AUTH_ERROR_DESCRIPTION: "كان هناك مشكلة في المصادقة. يرجى التحديث.",
	DELETE_CONFIRMATION_MODAL: {
		TITLE: "حذف الغرفة",
		DESCRIPTION: "هل أنت متأكد أنك تريد حذف هذه الغرفة؟",
		CANCEL: "إلغاء",
		DELETE: "حذف",
	},
	CREATE_ROOM_TOAST: {
		TITLE: "تم إنشاء الغرفة",
		DESCRIPTION: "غرفتك جاهزة للانضمام.",
	},
	CREATE_ROOM_FORM: {
		DESCRIPTION: "قم بتعيين اسم لغرفتك ليراه الآخرون.",
		NAME_LABEL: "اسم الغرفة",
		NAME_PLACEHOLDER: "اكتب اسم الغرفة",
		LANGUAGE: "اللغة",
		LANGUAGE_PLACEHOLDER: "حدد لغة",
		AUTO_DETECT: "الكشف التلقائي",
		ENGLISH_US: "الإنجليزية (الولايات المتحدة)",
		ENGLISH_IN: "الإنجليزية (الهند)",
		ARABIC_KSA: "العربية (المملكة العربية السعودية)",
		SPANISH_CR: "الإسبانية (كوستاريكا)",
		CATALAN_ES: "الكتالانية (إسبانيا)",
		PORTUGUESE_PT: "البرتغالية (البرتغال)",
		PORTUGUESE_BR: "البرتغالية (البرازيل)",
		ESTONIAN_EE: "الإستونية (إستونيا)",
		RUSSIAN_RU: "الروسية (روسيا)",
		MALTESE_MT: "المالطية (مالطا)",
		FILIPINO_PH: "الفلبينية (الفلبين)",
		SPANISH_MX: "الإسبانية (المكسيك)",
		CHINESE_CN: "الصينية (الماندرين)",
		VIETNAMESE_VN: "الفيتنامية (فيتنام)",
		KOREAN_KR: "الكورية (كوريا)",
		HINDI_IN: "الهندية (الهند)",
		PERSIAN_IR: "الفارسية (إيران)",
		LANGUAGE_DESCRIPTION: "حدد لغة للغرفة، لا يمكنك تغيير لغة الغرفة لاحقا.",

		INCPERSONDEFAULT: "دو، جين",
		CDCDEFAULT: "AB1234",
		HEARINGTYPEDEFAULT: "جلسة الاستماع اللاحقة للملاءمة",
		SCHEDULEDEFAULT: "11/28/2023, 10:30 am PST",
		ADVANCED: "إعدادات متقدمة",
		INCARCERATED_PERSON_PLACEHOLDER: "أدخل أسمك",
		CDC_PLACEHOLDER: "CDC أدخل رقم",
		HEARING_TYPE_PLACEHOLDER: "أدخل نوع السمع",
		INCARCERATED_PERSON: "شخص مسجون",
		CDC: "CDC",
		HEARING_TYPE: "نوع السمع",
		SCHEDULE: "جدول",
		PICKDATE: "اختر موعدا",
		STEP_DETAILS: "التفاصيل",
		STEP_MODEL: "النموذج",
		CONTINUE: "متابعة",
		BACK: "رجوع",
		MODEL_TITLE: "نموذج النسخ",
		MODEL_DESCRIPTION: "Choose the model everyone in this room starts with. You can lock it so participants keep it.",
		LOCK_MODEL: "Lock model for everyone",
		LOCK_MODEL_DESC: "Participants cannot change the transcription model in this room.",
		HOURS: "ساعات",
		MINUTES: "دقائق",
		SECONDS: "ثواني",
	},
	EXPORT_MODAL: {
		TOAST_FAILED_TITLE: "فشل التصدير",
		TOAST_FAILED_DESCRIPTION: "لا يمكن تصدير نص فارغ.",
		DOWNLOAD: "تحميل",
		DOWNLOAD_DESCRIPTION: "حدد الصيغة للتصدير وقم بتمكين الخيارات الإضافية.",
		SELECT_FORMAT: "حدد الصيغة",
		SELECT_FORMAT_PLACEHOLDER: "حدد صيغة التصدير",
		DOCUMENT: "مستند (.pdf)",
		SPREADSHEET: "جدول بيانات (.csv)",
		AUDIO: "صوت (.mp3)",
		DOCX: "مستند (.docx)",
	},
	TRANSLATE_DIALOG: {
		TITLE: "الترجمة",
		BODY: "هل ترغب في تطبيق هذا التغيير على جميع النصوص لهذا المستخدم؟",
		APPLY_TO_SPEAKER: "تطبيق على هذا المستخدم فقط",
		APPLY_ONCE: "تطبيق هنا فقط",
		APPLY_TO_ALL: "تطبيق على جميع المستخدمين",
		TRANSLATE: "ترجم",
	},
	GUEST_FORM: {
		TITLE: "وصول الضيف",
		DESCRIPTION: "أدخل عنوان بريدك الإلكتروني لتلقي رابط تسجيل دخول آمن",
		EMAIL_LABEL: "عنوان البريد الإلكتروني",
		EMAIL_PLACEHOLDER: "أدخل عنوان البريد الإلكتروني",
		EMAIL_REQUIRED: "عنوان البريد الإلكتروني مطلوب",
		EMAIL_INVALID: "يرجى إدخال عنوان بريد إلكتروني صحيح",
		SEND_LINK: "إرسال رابط تسجيل الدخول",
		SUCCESS_TITLE: "تحقق من بريدك الإلكتروني",
		SUCCESS_DESCRIPTION:
			"لقد أرسلنا رابط تسجيل دخول إلى عنوان بريدك الإلكتروني. انقر على الرابط للوصول إلى الغرفة.",
		ERROR_TITLE: "حدث خطأ ما",
		ERROR_DESCRIPTION:
			"فشل في إرسال رابط تسجيل الدخول. يرجى المحاولة مرة أخرى.",
		CANCEL: "إلغاء",
	},
	START_DATE_TIME: "تاريخ ووقت البدء",
	END_DATE_TIME: "تاريخ ووقت الانتهاء",
	REVERT_TO_ORIGINAL: "العودة إلى الأصل",
	SELECTED_LANGUAGE: "اللغة المختارة",
	TRANSLATION_INFO: "تمت ترجمة بعض النصوص من النص الأصلي.",
	INVITE_GUEST: "دعوة ضيف",
	INVITE_GUEST_DESCRIPTION:
		"دعوة مستخدم ضيف إلى الغرفة عن طريق إدخال اسمهم وعنوان بريدهم الإلكتروني",
	CREATED_BY: "تم الإنشاء بواسطة",
	VIEW_ALL: "عرض الكل",
	LOBBY: {
		LOBBY: "الردهة",
		WAITING_IN_LOBBY: "{name} ينتظر في الردهة",
		USERS_WAITING_IN_LOBBY: "إدارة المستخدمين الذين ينتظرون حاليا في الردهة.",
		SEND_INVITE: "إرسال دعوة",
		ADMIT: "سماح بالدخول",
		REJECT: "رفض",
		NO_PARTICIPANTS: "لا يوجد مشاركون في الردهة.",
	},
	CLOSE: "إغلاق",
	LOGIN_PAGE: {
		CAROUSEL_STORY_1:
			"اختبر النسخ في الوقت الفعلي مع تقنية التعرف المتقدمة على المتحدثين. مثالي للاجتماعات والمقابلات والمؤتمرات.",
		CAROUSEL_STORY_2:
			"وضع التباين العالي والخطوط القابلة للتخصيص ودعم اللغات المتعددة يضمن أن الجميع يمكنهم استخدام منصتنا بفعالية.",
		CAROUSEL_STORY_3:
			"محادثاتك محمية بأمان على مستوى المؤسسات. انضم إلى آلاف المهنيين الذين يثقون في uTranscribe.",
		CAROUSEL_STORY_4:
			"اختر طريقة التعريف أدناه وابدأ النسخ في ثوان. لا يتطلب إعداد معقد.",
		CDCR_TEAM_TITLE: "فريق Tech Unicorn",
		CDCR_TEAM_SUBTITLE: "عضو معتمد",
		OR_CONTINUE_WITH: "أو تابع مع",
		GUEST_ACCESS_SUBTITLE: "لست عضوا؟ انضم باستخدام معرف الاجتماع الخاص بك",
		WELCOME_TO: "مرحبا بك في",
		CHOOSE_IDENTIFICATION: "يرجى اختيار طريقة التعريف الخاصة بك",
		NEED_HELP: "تحتاج مساعدة؟ تواصل مع مكتب الدعم الخاص بنا.",
		CALL_SUPPORT: "اتصل على 1-877-742-2135",
		EMAIL_SUPPORT: "راسلنا على support@courtroom.tech",
	},
	SIZES: "الأحجام",
	DIAGNOSTICS: "التشخيصات",
	ROOM_BACKGROUND: "خلفية الغرفة",
	NOT_AVAILABLE: "غير متوفر",
	UNRECOGNIZED_SPEECH: "التعرف على الكلام غير متوفر",
	UNRECOGNIZED_SPEECH_TOOLTIP:
		"هذا النص غير متعرف عليه. يرجى التحقق من جودة الصوت والمحاولة مرة أخرى.",
	UNDETECTED: "غير مكتشف",
	MICROPHONE_QUALITY_WARNING:
		"يرجى التحقق من جودة الميكروفون لتحسين الدقة أو ضبط المسافة من الميكروفون",
	LOW_ACCURACY_WARNING: "دقة منخفضة",
	UNKNOWN: "غير معروف",
	TRANSCRIPTION_SETTINGS: {
		TRANSCRIPTION_SETTINGS: "إعدادات النسخ",
		GENERAL: "عام",
		GENERAL_HINT: "المظهر والخط واللغة",
		MODE_HINT: "سلوك النسخ",
		MODEL_HINT: "محرك المعالجة بالذكاء الاصطناعي",
		MODE: "الوضع",
		LIVE_TRANSCRIPTION: "النسخ الحي",
		SEGMENTED_TRANSCRIPTION: "النسخ المجزأ",
		FINAL_TRANSCRIPTION: "النسخ النهائي",
		LIVE_DESC:
			"شاهد النص الحي لحديثك في لوحة منفصلة أثناء التحدث. تُظهر اللوحة الرئيسية النص النهائي لجميع المتحدثين.",
		SEGMENTED_DESC:
			"اعرض نصًا مؤقتًا مجزأً في الوقت الفعلي، يتم تحديثه تلقائيًا إلى الإصدار النهائي.",
		FINAL_DESC:
			"اعرض النص النهائي فقط في اللوحة الرئيسية. لا يتم عرض النسخ الحي.",
		SPEED_VALUE: "السرعة: {value}x",
		SPEED: "السرعة",
		FONT_TEST: "تُحدث UTranscribe ثورة في الطريقة التي نلتقط بها الكلام ونفهمه.",
		FONT_SIZE: "حجم الخط",
		SPEED_DESC: "سرعة النسخ والتأخير",
		DELAY_DESC: "السرعة {speed}x = تأخير {delay} ثانية",
		MODEL: "النموذج",
		MODEL_TITLE: "نموذج النسخ",
		MODEL_DESC: "اختر نموذج الذكاء الاصطناعي المستخدم لمعالجة نسخك.",
		MODEL_DEFAULT: "الافتراضي",
		MODEL_WHISPER: "Allicorn Model 1",
		MODEL_GPT4O: "GPT-4o",
		MODEL_GPT4O_MINI: "GPT-4o Mini",
		MODEL_FAST: "Allicorn Model 2",
		MODEL_DEFAULT_DESC:
			"خدمة تحديد المتحدثين من Microsoft مع معالجة سريعة ودقة موثوقة لمعظم حالات الاستخدام.",
		MODEL_DEFAULT_SHORT_DESC:
			"تحديد المتحدثين السريع والموثوق لمعظم حالات الاستخدام.",
		MODEL_WHISPER_DESC:
			"نموذج Allicorn Model 1 مع دقة محسّنة لبيئات الصوت المعقدة والمفردات المتخصصة.",
		MODEL_WHISPER_SHORT_DESC:
			"دقة عالية للصوت المعقد والمصطلحات المتخصصة.",
		MODEL_GPT4O_DESC:
			"نموذج التفريغ OpenAI GPT-4o بأعلى دقة وفهم للغة.",
		MODEL_GPT4O_SHORT_DESC:
			"أعلى دقة تفريغ وفهم للصوت واللغات.",
		MODEL_GPT4O_MINI_DESC:
			"نموذج التفريغ OpenAI GPT-4o Mini الذي يوازن بين الدقة والسرعة.",
		MODEL_GPT4O_MINI_SHORT_DESC:
			"دقة تفريغ وسرعة متوازنتان.",
		MODEL_FAST_DESC:
			"خدمة التفريغ Allicorn Model 2 المُحسّنة للمعالجة منخفضة التأخير.",
		MODEL_FAST_SHORT_DESC:
			"معالجة تفريغ منخفضة التأخير.",
		MODEL_ENHANCED: "مُحسّن",
		MODEL_PREMIUM: "Premium",
		MODEL_BETA: "Beta",
		MODEL_BETA_TOOLTIP: "This feature is currently in beta. Expect occasional inaccuracies as we continue fine-tuning.",
		MODEL_LOCKED: "Model locked",
		MODEL_LOCKED_DESC: "The host fixed the transcription model when this room was created.",
		MODEL_LOCKED_HINT: "Locked by the room host.",
		DOMAIN_MATH_UNAVAILABLE: "Not available for the selected model.",
		DOMAIN_MATH: "مُحسّن للرياضيات",
		DOMAIN_MATH_DESC:
			"يعرض الرموز والمعادلات الرياضية المنطوقة كتدوين رياضي فعلي بدلاً من النص العادي.",
	},
	NO_AUDIO: "لم يتم اكتشاف أي صوت",
	NO_AUDIO_DESC:
		"الميكروفون غير مكتوم، ولكن لم يتم اكتشاف أي صوت. يرجى التحقق من إعدادات الميكروفون أو التبديل إلى ميكروفون آخر.",
	NO_TRANSCRIPTION: "لم يتم إنشاء نسخ",
	NO_TRANSCRIPTION_DESC: "لم يتم إنشاء النسخ. يرجى تحديث الصفحة.",
	SCROLLING_PAUSED: "تم إيقاف التمرير للأسفل مؤقتًا",
	RESUME: "استئناف",
} satisfies Translation;

export default de;
